import ScrollIndicator from './scroll-indicator';

export default ScrollIndicator;
export type * from './types';
